export default __webpack_public_path__ + "static/media/danger.67239f6a.svg";